import type { ReactElement } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthProvider';
import { AppLayout } from './components/AppLayout';
import { KeycloakAuthenticated } from './components/KeycloakAuthenticated';
import { ProtectedRoute } from './components/ProtectedRoute';
import { APP_ROUTES } from './lib/routes';
import { SearchPage } from './pages/SearchPage';
import { queryClient } from './lib/query-client';

function AppRoutes(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path={APP_ROUTES.search} element={<SearchPage />} />
        </Route>
        <Route path="*" element={<Navigate to={APP_ROUTES.search} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export function App(): ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <KeycloakAuthenticated onAuthenticating={<div style={{ padding: '2rem' }}>Authenticating...</div>}>
          <AppRoutes />
        </KeycloakAuthenticated>
      </AuthProvider>
    </QueryClientProvider>
  );
}
